import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { SubcategoryBuilder } from '../../models/builders/subcategory.builder';
import { getErrorHandlingOptions } from '../base/headers';
import { Subcategory } from '../../models/subcategory';

const subcategoryBody = (subcategory: Subcategory) => ({
  name: subcategory.name
});

@Injectable()
export class SubcategoryApiService {
  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${ environment.apiUrl }subcategories`;
  }

  getSubcategories() {
    return this.httpClient.get(`${ this.apiUrl }`, getErrorHandlingOptions())
      .pipe(
        map(SubcategoryBuilder.fromList)
      );
  }

  getSubcategory(hash: string) {
    return this.httpClient.get(`${ this.apiUrl }/${ hash }`)
      .pipe(
        map(SubcategoryBuilder.fromJson)
      );
  }

  createSubcategory(subcategory) {
    return this.httpClient.post(this.apiUrl, subcategoryBody(subcategory)).pipe(map(SubcategoryBuilder.fromJson));
  }

  updateSubcategory(subcategory: Subcategory) {
    return this.httpClient.put(`${ this.apiUrl }/${ subcategory.hash }`, subcategoryBody(subcategory));
  }

  deleteSubcategory(subcategory: Subcategory) {
    return this.httpClient.delete(`${ this.apiUrl }/${ subcategory.hash }`);
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/subcategory-api.service.ts